import styled from 'styled-components';
import {
  Box,
  ButtonPrimary,
  cssSpacing,
} from '@spotify-internal/encore-web';

export const StyledTrackRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${cssSpacing('base', '24px')};
  justify-content: space-between;
`;

export const StyledTrackRowInner = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTrackRowInfo = styled.div`
  display: flex;
  gap: ${cssSpacing('tighter-4', '8px')};
`;

export const StyledTrackNumber = styled.div`
  margin-right: ${cssSpacing('tighter-2', '16px')};
  margin-left: -${cssSpacing('tighter-4', '8px')};
`;

export const StyledImageContainer = styled.div`
  margin-right: ${cssSpacing('tighter-3', '12px')};
  display: flex;
`;

export const StyledTrackNameDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 88px;
`;

export const StyledTrackButton = styled(ButtonPrimary)`
  cursor: pointer;
  margin-bottom: ${cssSpacing('tighter-4', '8px')};
  margin-left: ${cssSpacing('tighter-4', '8px')};
`;

export const InactiveStyledTrackButton = styled(StyledTrackButton)`
  cursor: auto;
`;

export const StyledButtonContainer = styled.div`
  margin-bottom: ${cssSpacing('tighter-4', '8px')};
`;

export const PillsContainer = styled.div`
  margin-bottom: ${cssSpacing('tighter-2', '16px')};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
`;

export const StyledBox = styled(Box)`
  z-index: auto;
  cursor: initial;
`;

export const StyledNameAndExplicitTagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
`;
